import { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
  headlineLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  headline: string;
  children?: ReactNode | ReactNode[];
  className?: string;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export function SectionHeader({
  headlineLevel = 'h2',
  headline,
  children,
  className,
  ...props
}: Props) {
  const HeadlineTag = headlineLevel;

  return (
    <div
      className={twMerge(
        'border-b border-gray-200 flex justify-between pb-5 items-center mb-10',
        className,
      )}
      {...props}
    >
      <HeadlineTag className="font-oswald text-xl font-semibold text-gray-900 sm:text-2xl md:text-3xl">
        {headline}
      </HeadlineTag>
      <div>{children}</div>
    </div>
  );
}
